import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, LabModels, UserDetail, UserLocationFacility } from 'src/app/models';
import { CustomDatePipe } from 'src/app/pipes';
import { CustomDialogService, LabManagerService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { AddTestToModelComponent } from './add-test-to-model/add-test-to-model.component';

@Component({
  selector: 'bart-lab-by-model',
  templateUrl: './lab-by-model.component.html',
  styleUrls: ['./lab-by-model.component.scss'],
  providers:[CustomDatePipe,DialogService,CustomDialogService]
})
export class LabByModelComponent implements OnInit {
  public userInfo: UserDetail;
  tableHeader:any;
  labModels:LabModels[]=[]
  constructor
  (
    private _loaderService: LoaderService,
    public dialogService: CustomDialogService,
    private customDatePipe :CustomDatePipe,
    private _labManagerService:LabManagerService,
    private _userService: UserService,
  ) 
  {
    this.userInfo = AccessUserInfo.getUserInfo();
  }

  ngOnInit() 
  {
    this.loadLabModels();
    this.tableHeader = [
      { field: 'Model', header: 'Model', display: 'table-cell', width: "12%" },
      { field: 'EquipmentType', header: 'Equipment Type', display: 'table-cell',width: "10%"},
      { field: 'EquipmentSubType', header: 'Equipment Sub-Type', display: 'table-cell', width: "12%" },
      { field: 'Manufacturer', header: 'Manufacturer', display: 'table-cell',width: "8%" },
      { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell' },
      { field: 'StartDate', header: 'Start Date', display: 'table-cell', width: "7%"},
      { field: 'EndDate', header: 'End Date', display: 'table-cell', width: "7%" },
    ];
  }
  loadLabModels()
  {
    this._loaderService.show();
    this.labModels=[];
    let getLabModelsParam={
      GETLABMODELS: {
        Offset:new Date().getTimezoneOffset()
    }
  }
    this._labManagerService.getLabModels(getLabModelsParam).subscribe(response =>
    {
      this.labModels = response.getLabModels;
      this._loaderService.hide()
      this.labModels.forEach(item =>
        {
          item.LabTest=JSON.parse(item.LabTestJSON);
          item.TestDisplayName=item.LabTestJSON?(JSON.parse(item.LabTestJSON)).map(x=>x.TestDisplayName).join("; "):"";
          item.StartDateUTC=item.StartDate;
          item.StartDate=this.customDatePipe.transform(item.StartDate,"local","MM/dd/yyyy");
          item.StartDateSort=new Date (this.customDatePipe.transform(item.StartDate,"local","MM/dd/yyyy"));
          item.EndDate=this.customDatePipe.transform(item.EndDate,"local","MM/dd/yyyy");
          item.EndDateSort=new Date (this.customDatePipe.transform(item.EndDate,"local","MM/dd/yyyy"));
        });
    },
    (error)=>
    {
      this._loaderService.hide()
    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: "Filter_Active_Machine_Models",
      value: '',
      eventDescription:UserActionDescription.LABS_BY_MODEL_GRID_LOADED
    });
    //#endregion
  }
 /*.......add or modify lab test assignment popup..........*/
  
 editRecord(rowData:LabModels)
 {
  const ref = this.dialogService.open(AddTestToModelComponent, {
    header: rowData.TestDisplayName?"Modify Assignment" : "Add New Assignment",
    width: '50%',
    data : {rowData : rowData}
  });
  ref.onClose.subscribe(data => {
    this.loadLabModels();
  });
  //#region User Action Audit
 this._userService.logUserAction({
  userName: this.userInfo.userName,
  userAction: UserAction.BUTTON_CLICKED,
  screenName: ScreenName.LAB_MANAGER,
  screenPath: location.pathname,
  key: "ModelID",
  value: rowData.ModelID,
  eventDescription:UserActionDescription.LABS_BY_MODEL_EDIT_ICON_CLICKED
});
//#endregion
}
/*.........................................................*/
sortColumn(event) {
  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.SORT,
    screenName: ScreenName.LAB_MANAGER,
    screenPath: location.pathname,
    key: event.field,
    value: event.order === 1 ? 'ASC' : 'DESC',
    eventDescription:UserActionDescription.LABS_BY_MODEL_COLUMN_SORT
  });
  //#endregion
}	

paginate(event) {
  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.PAGE_CHANGED,
    screenName: ScreenName.LAB_MANAGER,
    screenPath: location.pathname,
    key: 'Selected_Page_No',
    value: (event.first / event.rows) + 1,
    eventDescription:UserActionDescription.LABS_BY_MODEL_PAGE_NO_CLICKED
  });
  //#endregion
}



}
